import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import constitutionModalSteps from '../constants/constitutionModalSteps';
import { useConstitutionModal } from '../context/ConstitutionModalContext';

const ConstitutionModalHeader: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useConstitutionModal();

  const isPreviewStep = data.step === constitutionModalSteps.PREVIEW;
  const isMovementsStep = data.step === constitutionModalSteps.MOVEMENTS;

  const getSubtitle = () => {
    if (isPreviewStep) {
      return t('ConstitutionPreviewSubtitle');
    }
    if (isMovementsStep) {
      return t('ConstitutionMovementsSubtitle');
    }
    return t('ConstitutionScriptureSubtitle');
  };

  const renderStepPill = (stepNumber: number, label: string, isActive: boolean) => (
    <span
      className={`badge ${isActive ? 'badge-primary' : 'badge-dim badge-outline-light'}`}
      data-testid={`constitution-step-pill-${stepNumber}`}
    >
      {stepNumber}. {label}
    </span>
  );

  return (
    <Modal.Header className="constitution-modal__header">
      <div className="d-flex flex-column flex-grow-1">
        <h5 className="modal-title mb-1">{t('Constitution')}</h5>
        <p className="text-soft small mb-0">{getSubtitle()}</p>
      </div>

      <div className="d-flex align-items-center">
        <div className="constitution-modal__step-pills d-none d-md-flex">
          {renderStepPill(1, t('ConstitutionStepScripture'), !isPreviewStep && !isMovementsStep)}
          {data.isExcelMode || isPreviewStep
            ? renderStepPill(2, t('ConstitutionStepPreview'), isPreviewStep)
            : renderStepPill(2, t('ConstitutionStepMovements'), isMovementsStep)}
        </div>

        <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
          <em className="icon ni ni-cross" />
        </a>
      </div>
    </Modal.Header>
  );
};

export default ConstitutionModalHeader;
